import { render, staticRenderFns } from "./industryManage.vue?vue&type=template&id=865fbcfc&scoped=true"
import script from "./industryManage.vue?vue&type=script&lang=js"
export * from "./industryManage.vue?vue&type=script&lang=js"
import style0 from "./industryManage.vue?vue&type=style&index=0&id=865fbcfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865fbcfc",
  null
  
)

export default component.exports